import { Component } from '@angular/core';

@Component({
  selector: 'app-confirmation-cancel-property',
  templateUrl: './confirmation-cancel-property.component.html',
  styleUrl: './confirmation-cancel-property.component.css'
})
export class ConfirmationCancelPropertyComponent {

}
